import React, { useContext, useEffect, useState } from "react";
import { Accordion, Divider, Icon, Menu } from "semantic-ui-react";
import AgentTransfer from "./AgentTransfer";
import QueueMetrics from "./QueueMetrics";

import { ConnectDataContext } from "../contexts/DataContext";
import { Disposition } from "./Disposition";
import { RequiredDisposition } from "./RequiredDisposition";
import { CallInfo } from "./CallInfo";
import { RecentCalls } from "./RecentCalls";
import { PhoneDirectory } from "./PhoneDirectory";
import { OutboundCalls } from "./OutboundCalls";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button, makeStyles } from "@material-ui/core";
import classes from "*.module.css";
import { Theme } from "@material-ui/core/styles";
import { Image } from "semantic-ui-react";

interface IProps {
    activeIndex?: number;
}
const useStyles = makeStyles((theme: Theme) => ({
    dialogContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    dispoDialogTitle: {
        fontSize: "24px !important",
    },
    dispositionDialog: {
        height: "400px",
        width: "600px",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
    },
    logoutButton: {
        width: "200px",
    },
    logoContainer: {
        flexGrow: 1,
        alignSelf: "flex-end",
        marginTop: "75px",
        display: "flex",
        justifyContent: "center",
    },
    logo: {
        width: "80%",
        display: "flex",
        alignItems: "end",
        paddingBottom: "20px",
    },
}));

/**
 * This panel will be displayed below the CCP iFrame
 */
export function SideMenu({ activeIndex: propIndex }: IProps) {
    //const logger = getLogger("SideMenu");

    const [activeIndex, setActiveIndex] = useState(propIndex || 0);
    const [dispositionSubmitted, setDispositionSubmitted] = useState(false);
    const [disposition, setDisposition] = useState("");

    const { agents, queues, phoneDirectoryItems, availableDispositions, showDispositions, contactId } =
        useContext(ConnectDataContext);

    const classes = useStyles();

    useEffect(() => {
        if (!showDispositions) {
            setDispositionSubmitted(false);
        }
    }, [showDispositions]);
    const handleClick = (e: any, titleProps: any) => {
        const newIndex = activeIndex === titleProps.index ? -1 : titleProps.index;
        setActiveIndex(newIndex);
    };

    const buildAccordion = () => {
        const items = [
            {
                label: "Phone Directory",
                component: <PhoneDirectory phoneDirectory={phoneDirectoryItems} />,
            },
            {
                label: "Manual Outbound Calls",
                component: <OutboundCalls />,
            },
            {
                label: `Agent Transfer (${agents.length})`,
                component: <AgentTransfer agents={agents} />,
            },

            {
                label: `Queue Metrics (${queues.length})`,
                component: <QueueMetrics queues={queues} />,
            },
            {
                label: "Call Details",
                component: <CallInfo />,
            },
            {
                label: "Call History",
                component: <RecentCalls />,
            },
            // {
            //     label: `Call Log (${callLog.length})`,
            //     component: <CallLog callLog={callLog} />,
            // },
        ];
        return items.map((item, index) => (
            <Menu.Item key={`component-${index}`}>
                <Accordion.Title active={activeIndex === index} index={index} onClick={handleClick}>
                    <Icon name="dropdown" />
                    {item?.label}
                </Accordion.Title>
                <Accordion.Content active={activeIndex === index} content={item?.component}></Accordion.Content>
            </Menu.Item>
        ));
    };

    return (
        <React.Fragment>
            <Dialog
                disableBackdropClick
                disableEscapeKeyDown
                open={showDispositions && !dispositionSubmitted}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className={classes.dialogContainer}
            >
                <DialogTitle className={classes.dispoDialogTitle} id="alert-dialog-title">
                    {"Please Select a Call Disposition"}
                </DialogTitle>
                <Divider />
                <DialogContent className={classes.dispositionDialog}>
                    <RequiredDisposition
                        dispositions={availableDispositions}
                        contactId={contactId}
                        setDispositionSubmitted={setDispositionSubmitted}
                        setDisposition={setDisposition}
                    />
                    <div className={classes.logoContainer}>
                        <div className={classes.logo}>
                            <Image src="top-logo.png" />
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
            {showDispositions && (
                <Disposition
                    disposition={disposition}
                    showDispositions={showDispositions}
                    dispositions={availableDispositions}
                    contactId={contactId}
                />
            )}
            <Accordion as={Menu} vertical>
                {buildAccordion()}
            </Accordion>
        </React.Fragment>
    );
}
